import { Link } from "react-router-dom";
import { InformationCommonPropsType } from "../../../../../Types/SearchResultType";
import ShowRatings from "../ShowRatings";
import { Href } from "../../../../../Constants/Constants";
import { H6, LI, P, UL } from "../../../../../AbstractElements";

const InformationCommon:React.FC<InformationCommonPropsType> = ({ item }) => {
  return (
    <div className="info-block">
      <Link to={Href}>{item.url}</Link>
      <H6>{item.title}</H6>
      <P>{item.detail}</P>
      <div className="star-ratings">
        <UL className="search-info simple-list flex-row flex-wrap">
          {item.showStar ? <ShowRatings item={item.showStar} /> : ""}
          <LI>{item.star}</LI>
          <LI>{item.vote}</LI>
          <LI>{item.news}</LI>
        </UL>
      </div>
    </div>
  );
};

export default InformationCommon;